// extracted by mini-css-extract-plugin
var _1 = "tjs-location-item__location";
export { _1 as "location" }
export default { "location": _1 }
